import * as d3 from "d3"
import { useEffect, useRef } from "react"
import { spaces } from "../../../../utils/styles"

export const NetCashFlowPlot = ({ data, width = 800, height = 310 }) => {
  const ref = useRef()

  useEffect(() => {
    d3.select(ref.current).selectAll("*").remove()

    const svg = d3.select(ref.current).attr("width", width).attr("height", height).append("g").attr("transform", "translate(50, -40)")

    svg
      .append("text")
      .attr("x", 385)
      .attr("y", 60)
      .attr("text-anchor", "middle")
      .attr("font-size", "18px")
      .attr("font-weight", "bold")
      .text("Net Cash Flow")

    const x = d3
      .scaleBand()
      .domain(data.map((d) => d.semester))
      .range([0, 685])
      .paddingInner(0.1)
      .paddingOuter(-0.45)

    const minNetCashFlow = d3.min(data, (d) => d.netCashFlowUsd) || 0
    const maxNetCashFlow = d3.max(data, (d) => d.netCashFlowUsd) + 200000 || 1
    const y = d3.scaleLinear().domain([minNetCashFlow, maxNetCashFlow]).range([360, 140])

    const chartGroup = svg.append("g").attr("transform", "translate(40, -60)")

    chartGroup
      .append("g")
      .attr("transform", "translate(0,360)")
      .call(d3.axisBottom(x))
      .selectAll("text")
      .attr("transform", "rotate(-70)")
      .attr("text-anchor", "middle")
      .attr("x", -27)
      .attr("dy", 0)

    chartGroup.append("g").call(
      d3
        .axisLeft(y)
        .ticks(10)
        .tickFormat((d) => (d / 1_000_000).toFixed(2) + "M"),
    )

    chartGroup
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("x", -250)
      .attr("y", -50)
      .attr("text-anchor", "middle")
      .attr("font-size", "12px")
      .text("Net Cashflow (US$)")

    chartGroup
      .append("g")
      .attr("class", "grid")
      .attr("transform", "translate(0,360)")
      .call(
        d3
          .axisBottom(x)
          .tickSize(-(360 - 140))
          .tickFormat(""),
      )
      .selectAll("line")
      .style("stroke", "#ccc")

    chartGroup.append("g").attr("class", "grid").call(d3.axisLeft(y).tickSize(-705).tickFormat("")).selectAll("line").style("stroke", "#ccc")

    chartGroup.append("line").attr("x1", 0).attr("x2", x.range()[1]).attr("y1", y(0)).attr("y2", y(0)).attr("stroke", "black")

    const getMaxPerSemester = (data) => {
      const grouped = {}
      data.forEach((d) => {
        if (!grouped[d.semester] || d.quarter > grouped[d.semester].quarter) {
          grouped[d.semester] = d
        }
      })
      return Object.values(grouped)
    }

    const performed = getMaxPerSemester(data.filter((d) => d.type === "performed"))
    const estimated = getMaxPerSemester(data.filter((d) => d.type === "estimated"))

    if (estimated.length && performed.length) {
      const intersection = {
        semester: performed[performed.length - 1].semester,
        netCashFlowUsd: performed[performed.length - 1].netCashFlowUsd,
      }

      estimated.unshift(intersection)
    }

    const performedLine = d3
      .line()
      .x((d) => x(d.semester) + x.bandwidth() / 2)
      .y((d) => y(d.netCashFlowUsd))

    const estimatedLine = d3
      .line()
      .x((d) => x(d.semester) + x.bandwidth() / 2)
      .y((d) => y(d.netCashFlowUsd))

    chartGroup.append("path").datum(performed).attr("fill", "none").attr("stroke", "#FAA061").attr("stroke-width", 3).attr("d", performedLine)

    chartGroup
      .append("path")
      .datum(estimated)
      .attr("fill", "none")
      .attr("stroke", "#FAA061")
      .attr("stroke-width", 3)
      .attr("stroke-dasharray", "4 4")
      .attr("d", estimatedLine)
  }, [data])

  return <svg ref={ref} style={{ minWidth: width, minHeight: height, marginRight: spaces.space1 }} />
}
